const licensingActionTypes =  {    
    RETRIEVED_LICENSING_PRODUCT: "RETRIEVED_LICENSING_PRODUCT",
    RETRIEVED_SERVER_INFO: "RETRIEVED_SERVER_INFO"
};
export default licensingActionTypes;
